export default "__VITE_ASSET__2eba1f96__"